import { Injectable } from '@angular/core';
import { Const } from '../../../static/const';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private http: HttpClient) {}

  productSubject = new BehaviorSubject<any>(true);
  productData$ = this.productSubject.asObservable();

  initialStateSubject = new BehaviorSubject<any>(true);
  initialStateData$ = this.initialStateSubject.asObservable();

  isTextEditorEnabledSubject = new BehaviorSubject<any>(false);
  isTextEditorEnabledData$ = this.isTextEditorEnabledSubject.asObservable();

  isAnyTextAddeddSubject = new BehaviorSubject<any>(false);
  isAnyTextAddedData$ = this.isAnyTextAddeddSubject.asObservable();

  isImageStateSubject = new BehaviorSubject<any>(false);
  isImageStateData$ = this.isImageStateSubject.asObservable();

  activePageSubject;

  getLanguages(data) {
    const url = Const.connectionUrl + '/api/get_country_language';
    return this.http.post(url, data);
  }

  convertFileType(data) {
    const url = Const.connectionUrl + '/api/convert_file_type';
    return this.http.post(url, data);
  }

  assetFromVeeva(data) {
    // const url = '../../../../assets/temp-data/asset-from-veeva.json';
    const url = Const.connectionUrl + '/api/get_documents';
    return this.http.post(url, data);
  }

  getSelectedAssetDetails(data) {
    // const url = '../../../../assets/temp-data/asset-from-veeva.json';
    const url = Const.connectionUrl + '/api/asset/documentbytes';
    return this.http.post(url, data);
  }
}
